import { JournalEntriesPopup } from './JournalEntriesPopup';

export default JournalEntriesPopup;
